import type { TConstraints } from '@feathr/rachis';

import { GoogleAdsCampaign } from './google_ads';
import type { IGoogleAdsSmartCampaign } from './types';
import { CampaignClass } from './types';

export class GoogleAdsSmartCampaign extends GoogleAdsCampaign<IGoogleAdsSmartCampaign> {
  public override getDefaults(): Partial<IGoogleAdsSmartCampaign> {
    return {
      ...super.getDefaults(),
      _cls: CampaignClass.GoogleAdsSmart,
    };
  }

  public override get constraints(): TConstraints<IGoogleAdsSmartCampaign> {
    return {
      ...super.constraints,
      destination_url: {
        url: {
          message: '^Website must be a valid URL.',
        },
        presence: {
          allowEmpty: false,
          message: "^Website can't be empty.",
        },
      },
      keyword_themes: {
        presence: {
          allowEmpty: false,
        },
      },
    };
  }
}
